export default "__VITE_ASSET__BXj46HFq__"